import type { HeaderMenuStoryblok, ULinkStoryblok } from '#core/storyblok-component-types'

export const useHeaderContent = () => useState<{
  default: HeaderMenuStoryblok[]
  pro: HeaderMenuStoryblok[]
  joinUnbiased: ULinkStoryblok[]
  sharedHeaderLinks: ULinkStoryblok[]
}>('headers')
export const useJoinUnbiasedDialog = () => useState('joinUnbiasedDialog', () => false)

export const useHeader = () => {
  const { getLink } = useLinkType()
  const headers = useHeaderContent()

  function mapLinkData(linkData: ULinkStoryblok) {
    const { link } = linkData

    return {
      ...linkData,
      ...getLink(link).props,
    }
  }

  function buildMenus(
    menus: HeaderMenuStoryblok[] = [],
    defaultMenu: ULinkStoryblok[] = [],
    overviewEnabled = true,
  ) {
    return menus.map(menu => {
      const { text, mainLink } = menu
      const mainLinks = menu.mainLinks?.map(mapLinkData) || []
      const optionalLinks = [
        ...(menu.optionalLinks?.map(mapLinkData) || []),
        ...defaultMenu.map(mapLinkData),
      ]

      return {
        mainLinks,
        optionalLinks,
        mainSubheader: menu.mainSubheader,
        optionalSubheader: menu.optionalSubheader,
        mainLink: {
          text,
          ...getLink(mainLink).props,
        },
        ...(overviewEnabled && {
          overviewLink: {
            title: 'Overview',
            ...getLink(menu.overviewLink).props,
          },
        }),
        ...(menu.ctaLink && {
          cta: {
            text: menu.ctaLabel,
            ...getLink(menu.ctaLink).props,
          },
        }),
      }
    }).filter(Boolean)
  }

  const header = computed(() => buildMenus(headers.value?.default, headers.value?.sharedHeaderLinks))
  const proHeader = computed(() => buildMenus(headers.value?.pro, [], false))
  const joinUnbiased = computed(() => headers.value?.joinUnbiased ?? [])

  return {
    header,
    proHeader,
    joinUnbiased,
  }
}
